<div class="modal-container">
	<div class="page-title">
		<div class="title">{{ (data.message ? data.message : message) | translate }}</div>
	</div>

	<div class="dialog-button-section">
		<button type="button" mat-button class="responsive-button btn confirm btn-fixed-width m-r-1rem" (click)="onConfirm()">{{ 'SYSTEM.CONFIRM' | translate }}</button>
		<button type="button" mat-button class="responsive-button btn cancel btn-fixed-width m-r-1rem" (click)="onNoClick()">{{ 'SYSTEM.CANCEL' | translate }}</button>
	</div>
</div>